<template>
  <div ref="mqttNew" style="height:100%;min-width: 1600px;">
    <div style="display:flex;">

      <img src="@/assets/images/GPDLOGO.png" style="height:60px;margin-left: 50px;">
      <span style="font-size: 46px;color: #93c737;margin-left: 30px;">GPD云平台</span>
    </div>
    <div style="background: #e3f1c7;height: 60px;padding-top: 10px;position: relative;top: 10px;">
      <div class="productDetail">
        <span style="font-size: 20px;margin-right: 20px;">{{ yhubInfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ yhubInfo.deviceSn }})</span>
        <span class="fontStyle1">设备:{{ yhubInfo.mechBrand }} {{ yhubInfo.mechModel }}</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">电池型号:{{ yhubInfo.batteryBrand }}  {{ yhubInfo.batteryModels }}</span>
        <span v-if="yhubInfo.batteryCapacity!=null" class="fontStyle1">&nbsp;&nbsp;容量:{{ yhubInfo.batteryCapacity }} Ah</span>
        <span class="fontStyle1">&nbsp;&nbsp;系统电压:{{ yhubInfo.batteryVoltage }} V</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">固件:{{ yhubInfo.fwVersion }}</span>
      </div>
    </div>

    <div ref="productPicture" class="productPicture" style="display: flex;justify-content: center;background:#f5faeb;padding-bottom: 60px;">
      <div>
        <!-- 左上角       -->
        <div style="display: inline-block;;align-items: center;">
          <div style="position: relative;display: inline-block; min-height:400px;width: 422px;">
            <!-- 充电器 -->
            <div style="position: absolute;">
              <img v-if="charger.chargerNetStatus==1" class="pic" src="@/assets/images/battery_color2.png">
              <img v-else class="pic" src="@/assets/images/battery_gray2.png">
            </div>
            <!-- 充电器描述 -->
            <div style="height:auto;position: absolute;top: 240px;left: 0px;">
              <!-- 充电器描述--文本框箭头 -->
              <div style="margin-bottom: -13px;display: flex;justify-content: center;">
                <img class="pic" src="@/assets/images/font_border_top_expo.png">
              </div>
              <!-- 充电器描述--文字 -->
              <div class="batteryDetail" style="min-width: 320px;">
                <div v-if="charger.chargerNetStatus == 1" style="width: 100%;">
                  <div style="color: #66a3dc;">
                    <p style="display:inline-block;">更新时间</p>
                    <p style="display:inline-block;">{{ chargerTime }}</p>
                  </div>

                  <p>型号{{ charger.chargerMode }} / 固件 V{{ charger.chargerFwVersion }} / 曲线 B{{ charger.curveNum }}</p>
                  <p>市电：{{ charger.supplyVoltage/100.00 }} V / {{ charger.supplyFrequence }} Hz</p>
                  <!-- <p>输出：电压{{charger.outputVoltage/100.00}} V / 电流{{charger.outputCurrent/100.00}} A / 电量{{charger.currentAh}} Ah</p> -->
                  <p>充电器{{ charger.chargerTemperature }} ℃ / 电池{{ charger.libatteryTemperature }} ℃</p>

                  <p :title="chargerWarnings" style="display: flex;" /></p><p v-if="chargerWarnings.length>=1">警告：</p>
                  <ul>
                    <li v-for="item in chargerWarnings"><span class="redRadiu" />{{ item }}</li>
                  </ul>
                  </p>
                </div>

                <div v-if="charger.chargerNetStatus !=1">
                  <br>
                  <p>温馨提示：</p>
                  <p><span class="redRadiu" />主人，我连不上充电器了~</p>
                  <br>
                  <br>
                </div>
              </div>
            </div>
          </div>
          <!-- 绿色箭头 -->
          <div style="display: inline-block;vertical-align: top;margin: 130px 100px;">
            <p style="text-align: center;margin-bottom: 10px;font-size:18px;">{{ charger.outputVoltage/100.00 }} V </p>
            <img v-if="charger.chargerNetStatus==1" class="pic" src="@/assets/images/arrow_green.gif">
            <img v-else class="pic" src="@/assets/images/arrow_green_gray.png">
            <p style="text-align: center;margin-top: 10px;font-size:18px;">{{ charger.outputCurrent/100.00 }} A</p>
          </div>
        </div>
        <!-- 右上角 -->
        <div style="vertical-align: top;display: inline-block;">
          <!-- 锂电池、状态、黄色箭头 -->
          <div style="width:auto;margin-top: 110px;display: inline-block;">
            <div class="batteryState" style="display:inline-block;vertical-align: top;margin: 45px 34px 0 0;">
              <img v-if="liCell.connection==1&&liCell.batStatus1" class="pic" src="@/assets/images/cell_state_full.png"><!--绿色：充电-->
              <img v-if="liCell.connection==1&&liCell.batStatus0" class="pic" src="@/assets/images/cell_state_charging.png"><!--蓝色：放电-->
              <img v-if="liCell.connection==1&&liCell.batStatus3" class="pic" src="@/assets/images/cell_state_charging.png"><!--橙色：高温-->
              <img v-if="liCell.connection!=1||liCell.connection==1&&liCell.batStatus2" class="pic" src="@/assets/images/cell_state_poor.png"> <!--灰色：无状态-->
            </div>
            <div class="batteryAndArrow" style="display: inline-block;width:180px;">
              <img v-if="liCell.connection==1" class="pic" src="@/assets/images/cell_color.png">
              <img v-if="liCell.connection!=1" class="pic" src="@/assets/images/cell_gray.png">
              <img v-if="inverter.connection==1" class="pic" src="@/assets/images/arrow_yellow.gif" style="margin: 30px 0px 25px 65px;">
              <img v-else class="pic" src="@/assets/images/arrow_yellow_gray.png" style="margin: 30px 0px 25px 65px;">
            </div>
          </div>
          <div style="display: inline-block;vertical-align: top;padding-right: 50px;margin-left: 100px;">
            <!-- 锂电池折线图 -->
            <div style="width: 354px;height: 166px;" @click="showPop">
              <p class="detailBtn" style="position: relative;top: 85px;left: 100px;padding: 0 5px;width: 150px;">查看实时电流电压</p>
              <img class="pic" src="@/assets/images/ammeter.png">
            </div>
            <!-- 锂电池描述 -->
            <div style="height: auto;position: absolute;margin-top: 46px;z-index: 2;" @click="goDetail">
              <div style="display: inline-block;z-index: 2;position: absolute;top:calc(50% - 20px);;left: -52px;">
                <img class="pic" src="@/assets/images/font_border_left_expo.png">
              </div>
              <div id="liCellDetail" ref="liCellDetail" class="batteryDetail" style="min-width: 260px;margin-left: -1px;">
                <div v-show="liCell.connection==1" style="width: 100%;">
                  <div style="color: #66a3dc;">
                    <p style="display:inline-block;">更新时间</p>
                    <p style="display:inline-block;">{{ liCellTime }}</p>
                  </div>
                  <p>电量：{{ liCell.soc }} %</p>
                  <!-- <p>状态：{{liCell.status}}</p> -->
                  <p>电压：{{ liCell.voltage }} V</p>
                  <p>电流：{{ liCell.current }} A</p>
                  <p>充电电量：{{ liCell.chargedah }} Ah</p>
                  <p>放电电量：{{ liCell.usedah }} Ah</p>

                  <p style="display: flex;">
                    <span v-if="liCellWarnings1.length>=1||liCellWarnings2.length>=1||liCellWarnings3.length>=1">警告：</span>
                    <ul>
                      <li v-for="item in liCellWarnings1"><span class="redRadiu" />{{ item }}</li>
                      <li v-for="item in liCellWarnings2"><span class="redRadiu" />{{ item }}</li>
                      <li v-for="item in liCellWarnings3"><span class="redRadiu" />{{ item }}</li>
                    </ul>
                  </p>
                  <!-- <div class='detailBtn' @click='goDetail'>点击查看详情</div> -->
                  <div class="detailBtn" style="margin-bottom: 5px;">查看详情</div>
                </div>
                <div v-if="liCell.connection!=1">
                  <br>
                  <p>温馨提示：</p>
                  <p><span class="redRadiu" />锂电池暂时不在线哦~</p>
                  <br>
                  <br>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 下面 -->
        <div id="inverter" ref="inverter">
          <!-- 逆电器描述 -->
          <div style="display: inline-block;width: 49%;vertical-align: top;position: relative;right: 30px;top: 50px;">
            <div style="position: relative;display: inline-block;float: right;margin-left: -13px;margin-top: 30px;z-index: 2;">
              <img class="pic" src="@/assets/images/font_border_right_expo.png">
            </div>
            <div style="display: inline-block;max-width: 60%;float: right;">
              <div class="batteryDetail" style="min-width: 260px;">
                <div v-if="inverter.connection==1" style="width: 100%;">

                  <div style="color: #66a3dc;">
                    <p style="display:inline-block;">更新时间</p>
                    <!-- <p>{{new Date(inverter.triggerTime*1000)}}</p> -->
                    <p style="display:inline-block;">{{ inverterTime }}</p>
                  </div>
                  <p>电池电压：{{ inverter.batVoltage/100.00 }} V</p>
                  <p>输出电压：{{ inverter.inverterOutVol/100.00 }} V</p>
                  <p>输出电流：{{ inverter.inverterOutCur/100.00 }} A</p>
                  <p>温度：{{ inverter.inverterTemperature }} ℃</p>
                  <p style="display: flex;font-size:16px;" /></p><p v-if="inverterWarnings.length>=1">警告：</p>
                  <ul>
                    <li v-for="item in inverterWarnings"><span class="redRadiu" />{{ item }}</li>
                  </ul>
                  </p>
                </div>

                <div v-if="inverter.connection!=1">
                  <br>
                  <p>温馨提示：</p>
                  <p><span class="redRadiu" />逆变器暂时不在线哦~</p>
                  <!-- <p><span class='redRadiu'></span>逆变器暂时不在线哦逆变器暂时不在线哦逆变器暂时不在线哦逆变器暂时不在线哦逆变器暂时不在线哦逆变器暂时不在线哦逆变器暂时不在线哦~</p>  -->
                  <br>
                  <br>
                </div>
              </div>
            </div>

          </div>
          <!-- 逆电器图片 -->
          <div style="position: relative;display: inline-block;left: 0px;width:49%">
            <img v-if="inverter.connection==1" class="pic" src="@/assets/images/inverter_color.png">
            <img v-if="inverter.connection==1" class="pic" src="@/assets/images/fan_color.gif" style="position: absolute;left: 270px;top: 110px;">
            <img v-if="inverter.connection==1" class="pic" src="@/assets/images/bulb.gif" style="position: absolute;top: 80px;left: 550px;">
            <img v-if="inverter.connection!=1" class="pic" src="@/assets/images/inverter_gray.png">
          </div>
        </div>
      </div>
      <div style="background: #e3f1c7;height: 20px;width: 100%;position: fixed;bottom: 10px;left:0;" />
      <div style="background: #a9d252;height: 20px;width: 100%;position: fixed;bottom: 0;left:0;" />
    </div>
    <div v-show="isShow" ref="pop" style="position: fixed;top: 0;width: 1700px;height: 800px;width: 100%;height: 100%;padding: 10%;z-index: 3;background: gray;background-color: rgba(0,0,0,0.5);">
      <div style="width: 80%;height: 50px;background: white;border-radius:10px 10px 0 0 ;"><i class="el-icon-close" style="font-size: 30px;float: right;padding: 0 30px;line-height: 50px;" @click="closePop" /></div>
      <div id="lineChart" ref="lineChart" v-loading="reportLoading" class="chart" style="width: 80%;min-width:200px;height: 600px;background: white;padding-bottom:30px;border-radius:0 0 10px 10px;" />
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { getDetailByMcuId, listMsgBMSData } from '@/api/system'

import mqtt from 'mqtt'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'
import { updateTime } from '@/utils/updateTime.js'

import yhubproto from '@/proto/yhubproto'
import apiproto from '@/proto/apiproto'
import protobuf from 'protobufjs'

const YhubRequest = yhubproto.lookup('framework.YhubRequest')
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')
var options = {}
var client = mqtt.connect(MQTT_SERVICE, options)
export default {
  data() {
    this.yhubproto
    this.protobuf
    return {
      yhubInfo: {},
      msgBMSData: {},
      topic: '',
      mcuId: '',
      deviceName: '',
      deviceID: '',
      chargerWarnings: [],
      liCellWarnings1: [],
      liCellWarnings2: [],
      liCellWarnings3: [],
      inverterWarnings: [],
      charger: {
        outputVoltage: 0,
        outputCurrent: 0
      },
      liCell: {},
      inverter: {},
      // dialogVisible: false,
      isShow: false,
      liCellDetailHeight: null,
      // 折线图
      optionLine: null,
      reportLoading: false,
      chartData: {
        d3: [], // +charge
        d5: [] // voltage
      },
      lineChart: null,

      chargerTime: null,
      inverterTime: null,
      liCellTime: null,
      timer: null,
      listQuery: {
        deviceName: this.$route.query.deviceName,
        mcuId: this.$route.query.mcuId,
        startDate: new Date().getTime() - 1000 * 60 * 60 * 1, // 前面1h的数据
        endDate: new Date().getTime()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮滚动事件
      this.mqttMSG()
      // 折线图
      this.lineChart = echarts.init(this.$refs.lineChart)
      // this.reportLoading = true
      // var color = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3']
      this.optionLine = {
        title: {
          text: '锂电池实时数据'
        },
        tooltip: {
          trigger: 'axis'
          // formatter: function(params) {
          //   params = params[0]
          // var date = new Date(params.name)
          // return date.toLocaleString('chinese', { hour12: false }) + '<br>温度:' + params.value[1]
        },

        xAxis: {
          type: 'time',
          nameLocation: 'start',
          name: '时间',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#909399'
            }
          }
        },

        yAxis: [{
          type: 'value',
          name: '电流(A)',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          }
        },
        {
          type: 'value',
          name: '电压(V)',
          position: 'right',
          max: 95,
          min: 5,
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: '电流',
          type: 'line',
          data: this.chartData.d3,
          // symbolSize: 2, // 设定实心点的大小
          markLine: {
            silent: true,
            data: [{
              yAxis: 0
            }]
          }
        }, {
          name: '电压',
          type: 'line',
          // symbolSize: 2, // 设定实心点的大小
          data: this.chartData.d5
        }

        ]
      }
      this.lineChart.setOption(this.optionLine, false)
    })
    this.mcuId = this.$route.query.mcuId
    // this.deviceName = this.$route.query.deviceName
    this.deviceID = 'WEB2_' + this.mcuId + '_' + this.getuuid()
    options = {
      connectTimeout: 40000,
      clientId: this.deviceId,
      username: MQTT_USERNAME,
      password: MQTT_PASSWORD,
      clean: true
    }
    console.log(this.$route.query)
  },
  created: function() {
    this.charger.chargerNetStatus = 0
    // this.mqttMSG()
    getDetailByMcuId({ 'mcuId': this.$route.query.mcuId }).then(response => {
      this.yhubInfo = response.resultModel
    })

    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器 // 折线图
    // clearInterval(this.timerCharger)
    // clearInterval(this.timerInverter)
    // clearInterval(this.timerLiCellTime)
    // this.timerCharger = this.timerInverter = this.timerLiCellTime = null
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()

    listMsgBMSData(this.listQuery).then(response => {
      const buf = protobuf.util.newBuffer(response)
      // var newBuf = buf.slice(0, buf.length - 2)
      this.gnssProto = GNSSProto.decode(buf)

      if (this.gnssProto.gnssMsgBMSData != null && this.gnssProto.gnssMsgBMSData.msgBMSData != null) {
        var bmsList = this.gnssProto.gnssMsgBMSData.msgBMSData
        for (var i = bmsList.length - 1; i >= 0; i--) {
          var data = bmsList[i]
          var time1 = data.yhubStime

          var cur = data.batTotalCur / 100.00
          var vol = data.batTotalVol / 100.00
          if (vol == 0) {
            continue
          }
          // var soc = data.bat_SOC
          // var temp1 = data.temp1
          // var temp2 = data.temp2
          // var usedah = data.usedah
          // var chargedah = data.chargedah

          // var time1 = this.msgBMSData.time * 1000
          // var volt = this.msgBMSData.BMS2CarFrame1.batTotalVol / 100.00
          // var cur = this.msgBMSData.BMS2CarFrame1.batTotalCur / 100.00
          this.chartData.d5.push([time1, vol])
          this.chartData.d3.push([time1, cur])
        }
        // if (this.lineChart != null) this.lineChart.clear()
        this.lineChart.setOption(this.optionLine, true)
        this.lineChart.resize()
      }
    })
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器  // 折线图
    // clearInterval(this.timerCharger)
    // clearInterval(this.timerInverter)
    // clearInterval(this.timerLiCellTime)
    // this.timerCharger = this.timerInverter = this.timerLiCellTime = null
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer() { // 折线图
      if (this.timer == null) {
        this.timer = setInterval(() => {
          // if(value=='chargerTime'){
          //   this.chargerTime = updateTime(myTime)
          // }else  if(value=='timerInverter'){
          //   this.timerInverter = updateTime(myTime)
          // }else  if(value=='timerLiCell'){
          //   this.timerLiCell = updateTime(myTime)
          // }
          if (this.charger.time) this.chargerTime = updateTime(this.charger.time * 1000)
          if (this.inverter.time) this.inverterTime = updateTime(this.inverter.time * 1000)
          if (this.liCell.time) this.liCellTime = updateTime(this.liCell.time * 1000)
        }, 60000)
      }
    },
    setTimerCharger(myTime) { // 折线图
      if (this.timerCharger == null) {
        this.timerCharger = setInterval(() => {
          this.chargerTime = updateTime(myTime)
        }, 60000)
      }
    },
    setTimerInverter(myTime) { // 折线图
      if (this.timerInverter == null) {
        this.timerInverter = setInterval(() => {
          this.inverterTime = updateTime(myTime)
        }, 60000)
      }
    },
    setTimerLiCell(myTime) { // 折线图
      if (this.timerLiCell == null) {
        this.timerLiCell = setInterval(() => {
          this.liCellTime = updateTime(myTime)
        }, 60000)
      }
    },
    handleScroll() {
      try {
        var productPicture = this.$refs.productPicture
        productPicture.parentElement.parentElement.parentElement.style.minWidth = productPicture.scrollWidth + 'px'
      } catch (error) {

      }
    },
    handleClose(done) {
      done()
    },
    showPop() {
      this.isShow = true
      this.$nextTick(function() {
        this.lineChart.resize()
      })
    },
    closePop() {
      this.isShow = false
    },
    mqttMSG() {
      // mqtt连接
      client.on('connect', (e) => {
        console.log('连接成功:')
        client.subscribe('gpd/#', { qos: 1 }, (error) => {
          if (!error) {
            console.log('订阅成功')
            // 发布主题gpd/#,消息内容为Hello mqtt
            // client.publish('gpd/#', 'Hello mqtt')
          } else {
            console.log('订阅失败')
          }
        })
      })
      // 接收消息处理
      client.on('message', (topic, message) => { // 传回来的message是已经通过protobuf转码了的
        // 判断response是否是arrayBuffer
        if (!topic.match(this.mcuId)) { return } // 在众多topic中匹配this.mcuId
        this.topic = topic
        var yhubRequest
        try {
          const buf = protobuf.util.newBuffer(message)
          var newBuffer = buf.slice(0, buf.length - 2)
          yhubRequest = YhubRequest.decode(newBuffer) // 通过decode对应YhubRequest字典，将数据newBuffer转换成json
        } catch (err) {
          this.msg = err.toString()
          return err
        }
        console.log('收到数据==>' + JSON.stringify(yhubRequest))
        if (yhubRequest) {
          if (yhubRequest.payload === 'mCan') {
            if (yhubRequest.mCan.payload === 'mInverterData') {
              this.inverter = yhubRequest.mCan.mInverterData
              // this.inverter.time = updateTime(this.inverter.time * 1000)
              this.inverter.time = this.inverter.triggerTime
              this.inverterTime = '刚刚'
              // clearInterval(this.timer)
              // this.timer = null
              // this.setTimerInverter(this.inverter.time * 1000)
              // this.setTimer(this.inverter.time * 1000,'timerInverter')
              if (yhubRequest.mCan.mInverterData.errorCode != null) {
                this.inverterWarnings = []
                var errorCodeInt = yhubRequest.mCan.mInverterData.errorCode
                if (this.getBit(errorCodeInt, 1)) {
                  this.inverterWarnings.push('DC输入低压保护')
                }
                if (this.getBit(errorCodeInt, 2)) {
                  this.inverterWarnings.push('DC输入电压过压保护')
                }
                if (this.getBit(errorCodeInt, 3)) {
                  this.inverterWarnings.push('过载、输出短路保护、AC反接保护')
                }
                if (this.getBit(errorCodeInt, 4)) {
                  this.inverterWarnings.push('逆变器过温保护')
                }
                if (this.getBit(errorCodeInt, 5)) {
                  this.inverterWarnings.push('输入低电压报警')
                }
                if (this.getBit(errorCodeInt, 6)) {
                  this.inverterWarnings.push('逆变器过载')
                }
                if (this.getBit(errorCodeInt, 7)) {
                  this.inverterWarnings.push('逆变器过温报警')
                }
                if (this.getBit(errorCodeInt, 10)) {
                  this.inverterWarnings.push('充电器输出过压保护')
                }
                if (this.getBit(errorCodeInt, 11)) {
                  this.inverterWarnings.push('电池充电失败')
                }
                if (this.getBit(errorCodeInt, 12)) {
                  this.inverterWarnings.push('继电器过温保护')
                }
                if (this.getBit(errorCodeInt, 13)) {
                  this.inverterWarnings.push('输出GFCI跳了，没有AC输出')
                }
                if (this.getBit(errorCodeInt, 14)) {
                  this.inverterWarnings.push('通讯故障')
                }
              }
            }
            if (yhubRequest.mCan.payload === 'mChargerControl') {
              this.chargerWarnings = []

              this.charger = yhubRequest.mCan.mChargerControl.chargerinfo
              // console.log('this.charger.time-----------------------', this.charger.time)
              // this.chargerTime = updateTime(this.charger.time * 1000)
              // this.chargerTime = '刚刚'
              // clearInterval(this.timerCharger)
              // this.timerCharger = null
              // this.setTimerCharger(this.charger.time * 1000)

              this.chargerTime = '刚刚'
              // clearInterval(this.timer)
              // this.timer = null
              // this.setTimerInverter(this.inverter.time * 1000)
              // this.setTimer(this.charger.time * 1000,'chargerTime')
              // this.charger.time = this.charger.time * 1000
              if (yhubRequest.mCan.mChargerControl.chargerinfo.errorInfo != null) {
                var errorInfoInt = yhubRequest.mCan.mChargerControl.chargerinfo.errorInfo

                if (this.getBit(errorInfoInt, 1)) {
                  this.chargerWarnings.push('没有检测到电池')
                }
                if (this.getBit(errorInfoInt, 2)) {
                  this.chargerWarnings.push('市电异常')
                }
                if (this.getBit(errorInfoInt, 3)) {
                  this.chargerWarnings.push('机器高温保护')
                }
                if (this.getBit(errorInfoInt, 4)) {
                  this.chargerWarnings.push('电池高温保护')
                }
                if (this.getBit(errorInfoInt, 5)) {
                  this.chargerWarnings.push('机器内部故障')
                }
                if (this.getBit(errorInfoInt, 6)) {
                  this.chargerWarnings.push('输出端检测到高电压')
                }
                if (this.getBit(errorInfoInt, 7)) {
                  this.chargerWarnings.push('地址声明错误')
                }
              }
            }
            if (yhubRequest.mCan.payload === 'mBMSData') {
              // if (yhubRequest.mCan.payload === 'mBMSData') {
              console.log('收到数据mBMSData==>' + JSON.stringify(yhubRequest))

              this.liCell.connection = yhubRequest.mCan.mBMSData.connection
              if (this.liCell.connection !== 1) {
                return
              }

              this.liCell.time = yhubRequest.mCan.mBMSData.time
              this.liCellTime = '刚刚'
              // clearInterval(this.timerLiCellTime)
              // this.timerLiCellTime = null
              // console.log('this.liCell.time=======================', this.liCell.time * 1000)
              // this.setTimerLiCell(this.liCell.time * 1000)
              if (yhubRequest.mCan.mBMSData.BMS2CarFrame1) {
                this.liCell.current = yhubRequest.mCan.mBMSData.BMS2CarFrame1.batTotalCur / 100.00
                this.liCell.voltage = yhubRequest.mCan.mBMSData.BMS2CarFrame1.batTotalVol / 100.00
                this.liCell.soc = yhubRequest.mCan.mBMSData.BMS2CarFrame1.bat_SOC / 100
              }

              this.liCell.chargedah = yhubRequest.mCan.mBMSData.chargedah / 100
              this.liCell.usedah = yhubRequest.mCan.mBMSData.usedah / 100

              this.msgBMSData = yhubRequest.mCan.mBMSData
              this.totalCharge = this.msgBMSData.chargedah / 100.00
              this.totalDischarge = this.msgBMSData.usedah / 100.00
              // this.chargeTime = updateTime(this.msgBMSData.time * 1000)
              // 仪表图
              if (this.option && this.msgBMSData.BMS2CarFrame1.bat_SOC) this.option.series['0'].data['0'].value = this.msgBMSData.BMS2CarFrame1.bat_SOC / 100
              if (this.option) this.myChart.setOption(this.option, true)
              // 八组电池
              this.batterys = this.msgBMSData.singlevol.singlevol
              this.temps = this.msgBMSData.temperature.temperature
              this.max = Math.max(...this.batterys)
              this.min = Math.min(...this.batterys)
              this.chargeVol = this.msgBMSData.BMS2CarFrame1.batTotalCur / 100.00
              this.disChargeVol = this.msgBMSData.BMS2CarFrame1.batTotalCur / 100.00
              // 折线图
              var time1 = this.msgBMSData.time * 1000
              var volt = this.msgBMSData.BMS2CarFrame1.batTotalVol / 100.00
              var cur = this.msgBMSData.BMS2CarFrame1.batTotalCur / 100.00

              if (this.chartData.d3.length >= 1000) {
                this.chartData.d3.shift()
                this.chartData.d5.shift()
              }

              this.chartData.d5.push([time1, volt])
              this.chartData.d3.push([time1, cur])
              // if (this.lineChart != null) this.lineChart.clear()
              // this.lineChart.setOption(this.optionLine, true)
              // this.lineChart.resize()

              if (this.lineChart != null) {
                this.lineChart.setOption({
                  series: [{
                    data: this.chartData.d3

                  }, {
                    data: this.chartData.d5

                  }]
                })
              }

              if (yhubRequest.mCan.mBMSData.BMS2CarFrame1 != null) {
                this.liCellWarnings1 = []
                this.liCellWarnings2 = []
                this.liCellWarnings3 = []
                var sys_Status1Int = yhubRequest.mCan.mBMSData.BMS2CarFrame1.sys_Status1 // 充电
                if (sys_Status1Int !== 0) {
                  console.log('警告数据==>' + sys_Status1Int)
                  if (this.getBit(sys_Status1Int, 0)) {
                    this.liCellWarnings1.push('充电单体过压')
                  }
                  if (this.getBit(sys_Status1Int, 1)) {
                    this.liCellWarnings1.push('充电总压过压')
                  }
                  if (this.getBit(sys_Status1Int, 2)) {
                    this.liCellWarnings1.push('充电温度过高')
                  }
                  if (this.getBit(sys_Status1Int, 3)) {
                    this.liCellWarnings1.push('充电温度过低')
                  }
                  if (this.getBit(sys_Status1Int, 4)) {
                    this.liCellWarnings1.push('充电过流')
                  }
                  if (this.getBit(sys_Status1Int, 5)) {
                    this.liCellWarnings1.push('充电机故障')
                  }
                  if (this.getBit(sys_Status1Int, 6)) {
                    this.liCellWarnings1.push('绝缘过低')
                  }
                  if (this.getBit(sys_Status1Int, 7)) {
                    this.liCellWarnings1.push('通信中断')
                  }
                }
                var sys_Status2Int = yhubRequest.mCan.mBMSData.BMS2CarFrame1.sys_Status2 // 放电
                if (sys_Status2Int !== 0) {
                  console.log('警告数据==>' + sys_Status2Int)
                  if (this.getBit(sys_Status2Int, 0)) {
                    this.liCellWarnings2.push('放电单体欠压')
                  }
                  if (this.getBit(sys_Status2Int, 1)) {
                    this.liCellWarnings2.push('放电总压过低')
                  }
                  if (this.getBit(sys_Status2Int, 2)) {
                    this.liCellWarnings2.push('放电温度过高')
                  }
                  if (this.getBit(sys_Status2Int, 3)) {
                    this.liCellWarnings2.push('放电温度过低')
                  }
                  if (this.getBit(sys_Status2Int, 4)) {
                    this.liCellWarnings2.push('放电过流')
                  }
                  if (this.getBit(sys_Status2Int, 5)) {
                    this.liCellWarnings2.push('压差过大')
                  }
                  if (this.getBit(sys_Status2Int, 6)) {
                    this.liCellWarnings2.push('温差过大')
                  }
                  if (this.getBit(sys_Status2Int, 7)) {
                    this.liCellWarnings2.push('危险电压保护')
                  }
                }

                var sys_Status3Int = yhubRequest.mCan.mBMSData.BMS2CarFrame1.sys_Status3 // 橙色警告
                if (sys_Status3Int !== 0) {
                  console.log('警告数据==>' + sys_Status3Int)
                  if (this.getBit(sys_Status3Int, 0)) {
                    this.liCellWarnings2.push('SOC低')
                  }
                  if (this.getBit(sys_Status3Int, 1)) {
                    this.liCellWarnings2.push('放电总电压过压')
                  }
                  if (this.getBit(sys_Status3Int, 2)) {
                    this.liCellWarnings1.push('充电总电压欠压')
                  }
                  if (this.getBit(sys_Status3Int, 3)) {
                    this.liCellWarnings2.push('放电单体过压')
                  }
                  if (this.getBit(sys_Status3Int, 4)) {
                    this.liCellWarnings1.push('充电单体欠压')
                  }
                  if (this.getBit(sys_Status3Int, 5)) {
                    this.liCellWarnings1.push('充电温度过低')
                  }
                  if (this.getBit(sys_Status3Int, 6)) {
                    this.liCellWarnings2.push('放电温度过高')
                  }
                  if (this.getBit(sys_Status3Int, 7)) {
                    this.liCellWarnings2.push('继电器粘连')
                  }
                }
              }
              if (yhubRequest.mCan.mBMSData.BMS2CarFrame4) { var batStatus = yhubRequest.mCan.mBMSData.BMS2CarFrame4.sys_Status3 || '0' }
              this.liCell.batStatus0 = this.liCell.batStatus1 = this.liCell.batStatus2 = this.liCell.batStatus3 = false
              if (this.getBit(batStatus, 0)) {
                this.liCell.batStatus0 = true
              }
              if (this.getBit(batStatus, 1)) {
                this.liCell.batStatus1 = true
              }
              if (this.getBit(batStatus, 2)) {
                this.liCell.batStatus2 = true
              }
              if (this.getBit(batStatus, 3)) {
                this.liCell.batStatus3 = true
              }
              // } else {
              //   return
              // }

              try {
                this.$nextTick(function() {
                  console.log(this.$refs.liCellDetail)
                  this.liCellDetailHeight = this.$refs.liCellDetail.clientHeight + 'px'
                  console.log('this.liCellDetailHeight---------------------', this.liCellDetailHeight)
                  if (parseInt(this.liCellDetailHeight) > 310) {
                    this.$refs.inverter.style.marginTop = parseInt(this.liCellDetailHeight) - 310 + 'px'
                  }
                })
              } catch (error) {}
            }
          }
        }
        // console.log('收到来自', topic, '的消息', yhubRequest)
        this.msg = yhubRequest
      }
      )
      // 断开发起重连
      client.on('reconnect', (error) => {
        console.log('正在重连:', error)
      })
      // 链接异常处理
      client.on('error', (error) => {
        console.log('连接失败:', error)
      })
    },
    // uuid随机生成
    getuuid() {
      var uid = []
      var hexDigits = '0123456789abcdefghijklmnopqrst'
      for (var i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      uid[6] = '4'
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1)
      var uuid = uid.join('')
      return uuid
    },
    handleChange(val) {
      console.log(val)
    },
    getBit(n, k) {
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    },
    goDetail() {
      // this.$router.push({
      //   name: 'Battery',
      //   query: this.$route.query
      // })
      // const routeData = this.$router.resolve({
      //   path: '/battery/batteryDetail',
      //   query: this.$route.query
      // })
      // window.open(routeData.href, '_self')
    }

  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
  *{
    padding:0;
    margin:0;
    font-family: '微软雅黑';
  }
  li{
    list-style: none;
    font-size:16px;
  }
  .productDetail{
    height:50px;
    width: 100%;
    background: #a9d252;
    // margin: 10px 0;
    display: flex;
    align-items: center;
    font-family: "微软雅黑";
    padding-left:10px;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
    padding-left:50px;
  }
  .fontStyle1{
    font-size: 18px;
  }
  .fontStyle2{
    height: 32px;
    width: 2px;
    background: black;
    margin: 0 20px;
  }
  .productPicture{
    background:white;
    min-height: calc(100% - 55px);
    padding-top: 22px;
  }
  .batteryDetail{
    border-radius: 20px;
    padding:0 10px;
    border: 8px solid #e3d8d8;
    align-items: center;
    display: flex;
    min-width: 260px;
  }
  .batteryDetail li{
    margin:5px 0;
  }
  .batteryDetail p{
    margin: 8px 0;
    font-size: 16px;
  }
  .redRadiu{
    width: 10px;
    height: 10px;
    background: red;
    display: inline-block;
    border-radius: 50%;
    margin: 0 5px 0 0;
  }
  .detailBtn{
    width: 116px;
    height: 36px;
    background: #63bb38;
    border-radius: 10px;
    font-size: 14px;
    line-height: 36px;
    text-align: center;
    left: 160px;
    color: white;
    cursor: pointer;
  }
</style>

